import React, { Suspense } from 'react';
import Spinner from 'components/Spinner';

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<Spinner />}>
      <Component {...props} />
    </Suspense>
  );
};

export default Loadable;
